import ContactUs from "../components/ContactUs/ContactUs";

const ContactPage = () => {
    return (<main>
        <ContactUs />
        <br/>
        <br/>
    </main>
    );
};

export default ContactPage;
